import { render, staticRenderFns } from "./FormDisplayBlock.vue?vue&type=template&id=76fb8383"
import script from "./FormDisplayBlock.vue?vue&type=script&lang=js"
export * from "./FormDisplayBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports